import React from 'react';
import styles from './Home.module.scss';

const Home: React.FC = () => {

  return <div className={styles.main}>
 
  </div>
}
export default Home;